module.exports = __webpack_public_path__ + "static/Image23@2x-4e866b56754d461b0d712d5b37d4b2f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image23@2x.jpg
// module id = 916
// module chunks = 227233210825294 244429959259914